/**
 * @file: 组件快捷移动
 * @author: xiaolong.huang@dmall.com
 */

import Move from '../move/index';
import History from '../history/index';
import { updateCubeList } from '../../update/updateCubeList';
import { runForceUpdate } from '../../update/runForceUpdate';
import { updateEnd } from '../../update/updateEnd';
import { findAllSelectedCanMove, makeMoveTaskQueue } from './toolkit';

function move(direction: string): void {
    let moveCubes: Array<CubeId> = findAllSelectedCanMove();
    let shortMoveTask: MoveTask = makeMoveTaskQueue(moveCubes, direction);
    let physicsMoveUpdateList: CubeId[] = Move.physicsUpdateList(shortMoveTask);
    let logicMoveUpdateList: CubeId[] = Move.logicUpdateList(shortMoveTask, physicsMoveUpdateList);
    let updateList: CubeId[] = physicsMoveUpdateList.concat(logicMoveUpdateList);
    let forceUpdate: CubeId[] = Move.forceUpdateList(shortMoveTask);
    let moveGoBackTask: MoveTask = Move.makeBackMoveTask(shortMoveTask);

    History.stackIn({
        type: 'shortMove',
        data: [moveGoBackTask]
    });
    Move.physics(shortMoveTask.physics);
    Move.logic(shortMoveTask.logic);
    updateCubeList(updateList);
    runForceUpdate(forceUpdate);
    updateEnd();
}

export {
    move
};
